import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectDuplicateModalComponent } from '../project-duplicate-modal/project-duplicate-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonLegacyModule, DialogModule, FormModule } from 'studio-components';

@NgModule({
  declarations: [ProjectDuplicateModalComponent],
  exports: [ProjectDuplicateModalComponent],
  imports: [CommonModule, ReactiveFormsModule, ButtonLegacyModule, DialogModule, FormModule],
})
export class ProjectDuplicateModalModule {}
